var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 90,
    viewBox: "0 0 73.0 90.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8787,15.2929L37.2929,13.8787A1,1 119.0546,0 1,38.7071 13.8787L40.1213,15.2929A1,1 0,0 1,40.1213 16.7071L38.7071,18.1213A1,1 84.4413,0 1,37.2929 18.1213L35.8787,16.7071A1,1 50.5944,0 1,35.8787 15.2929z",
    fill: "#fff3cdff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4645,20.2929L43.2929,17.4645A1,1 128.8023,0 1,44.7071 17.4645L47.5355,20.2929A1,1 81.9054,0 1,47.5355 21.7071L44.7071,24.5355A1,1 119.0546,0 1,43.2929 24.5355L40.4645,21.7071A1,1 0,0 1,40.4645 20.2929z",
    fill: "#fff3cdff",
    strokeWidth: 1,
    stroke: "#00000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank4);
export default __webpack_public_path__ + "static/media/rank4.9b0ae0c5f7135982ce4aa10ccd441279.svg";
export { ForwardRef as ReactComponent };